<template>
	<!--pc-->
	<div class="im-box"  > 
	 
	</div>
    
	 

</template>

<script>
	import {
		mapState
	} from "vuex";
	import Fingerprint2 from 'fingerprintjs2'
    import io from 'socket.io-client'
	 
	export default {
		name: "Im",
		props: {
			 
		},
		data() {
			return {
				user_info: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : '',
				ws: "",
			    chat_token:"",
				socket_heart:'',
				socket_url: process.env.VUE_APP_CHAT_SOCKET_API,
				lockReconnect:false
			};
		},
		computed: {
			 
		},
		watch: {
			 
		},
		methods: {
			 userLogin() {
				 this.chat_token=localStorage.getItem("im_token");
				 if(!this.chat_token){
					 return;
				 }
				// console.log(this.user_info,"===user_info===user_info==");
				 this.connSocket();
				 
			},
			connSocket(){
				// 创建连接
				try {
					if(window.WebSocket) {
						// console.log(this.socket_url);
						this.ws = new WebSocket(this.socket_url);
						this.listen();
					}
				} catch(e) {
					this.reconnectWebSocket();
				}
			},
			// 初始化
			listen(){
				let _this = this;
				if (!_this.ws && _this.ws.readyState != WebSocket.OPEN) return false;
				_this.ws.onopen = function () {}
				_this.ws.onmessage = function (data) {
					let res = JSON.parse(data.data)
					if (res.type === 'init'){
						// 登录
						if (_this.ws != null && _this.ws.readyState == WebSocket.OPEN) {
							// console.log(_this.user_info)
							let t = JSON.stringify({type: "login", token: _this.chat_token})
							_this.ws.send(t);
							// console.log('send', t);
						} else {
							console.log("WebSocket 连接没有建立或已关闭");
						}
					}else{
						_this.ChatEnvent(res);
					}
					// 开启心跳
					if (!_this.socket_heart && _this.ws && _this.ws.readyState == WebSocket.OPEN){
						_this.socket_heart = setInterval(function () {
							let t = JSON.stringify({type: 'heart'})
							_this.ws.send(t);
						}, 30000)
					}
				}
				_this.ws.onclose  = function (data) {
					_this.reconnectWebSocket();
				}
				_this.ws.onerror  = function (data) {
					_this.reconnectWebSocket();
				}
			},
			// 重连
			reconnectWebSocket() {
				let _this = this;
				if(_this.lockReconnect) return;
				_this.lockReconnect = true;
				setTimeout(function(){
					console.log("WebSocket 尝试重新连接");
					_this.lockReconnect = false;
					_this.connSocket();
				}, 5000)
			},
			// socket事件
			ChatEnvent(res) {
				let _this = this
				if (res.type == 'receive'){
					if(this.user_info.info.id!=res.content.uinfo.user_id){
						this.$tool.playMessageAudio();
							
					}
				// 	res.content.msg = res.content.msg.replace(/\n/g,"<br>");
				// 	this.messageList.push(res.content);
				// 	setTimeout(function() {
				// 		_this.scrollEnd()
				// 	});
				// 	this.sendS('read', res.content.record_id, 0);
				// }else if (res.type == 'login'){
				// 	// 拉取聊天记录
				// 	this.$api["post2"]("chat/records", {page:this.param.page,limit:this.param.limit,clear:1,cid:this.param.conversation_id}, 1).then(({
				// 		data
				// 	}) => {
				// 		for (var i = 0; i <data.data.length; i++) {
				// 			data.data[i].msg = data.data[i].msg.replace(/\n/g,"<br>");
				// 		}
				// 		_this.messageList = data.data;
				// 		setTimeout(function() {
				// 			_this.scrollEnd()
				// 		}, 100);
				// 	})
				}
				return true
			},
			// sendS(action, content, content_type){
			// 	let msg = {type:action};
			// 	if(action == 'send'){

			// 	}else if(action == 'read') {
			// 		msg.record_id = content
			// 	}
			// 	this.ws.send(JSON.stringify(msg));
			// 	this.content = '';
			// },


			// connSocket_bak() {
			// 	this.ws = io('wss://zsws.inspector.ltd', {
			// 		query: {
			// 			token: this.chat_token
			// 		},
			// 		transports: ['websocket'],
			// 		autoConnect: true,
			// 	});
            //     //console.log(`normal_chat#${this.user_info.info.id}`)
			// 	this.ws.emit('subcribe', {
			// 		channel: `normal_chat#${this.user_info.info.id}`,
			// 		data: {
			// 			...this.user_info.info,
			// 			token: this.chat_token
			// 		},
			// 	});
				 
				 
			// 	this.ws.on('chat_new_message', (data) => {
			// 		 console.log(data,"===data===");
			// 		 var new_msg_count = document.getElementById('new_msg_count');
			// 		 if(new_msg_count){
			// 			 var num=new_msg_count.innerText*1;
			// 			     num++;
			// 			 new_msg_count.innerText=num;
			// 			 new_msg_count.style.display="inline";
			// 		 }
					 
			// 		  this.$tool.playMessageAudio();
					
			// 	});
			     
			// },
			 
			 
		},
		mounted() {
		 
		},
		created() {
		 this.userLogin();
		},
		destroyed() {
			// this.ws.emit('unsubcribe', {
			// 	channel: `normal_chat#${this.user_info.info.id}`,
			// 	data: {
			// 		...this.user_info.info,
			// 		token: this.chat_token
			// 	},
			// });
			// console.log("页面关闭"); 
		}
	};
</script>
 